module.exports = __webpack_public_path__ + "media/images/game_icon/en/VG0002-f38ac6fe0ac7a4b46a17504d5eedf2e6.png";